<template>
    <div class="oa-dashboard-app page-container md-layout-column" id="app">
        <md-app>
            <md-app-toolbar class="md-primary thin">
                <img class="logo" src="https://firebasestorage.googleapis.com/v0/b/ee-stem.appspot.com/o/dashboard%2FStrata-C-banner.png?alt=media&token=37761c28-639f-4681-b3fc-d8ef47a12d05"/>
                <div class="md-toolbar-section-start">
                    <a href="/">
                        <!-- <div class="title">Strata Open Access Dashboard</div> -->
                    </a>
                </div>
                 <md-button class="md-icon-button" href="https://app.unepstrata.org/" target="_blank">
                    <md-icon>travel_explore</md-icon>
                    <md-tooltip md-direction="top">Builder tool</md-tooltip>
                </md-button>
                <md-button class="md-icon-button" href="https://unepstrata.org/resources/" target="_blank">
                    <md-icon>help</md-icon>
                    <md-tooltip md-direction="top">Resources</md-tooltip>
                </md-button>
                <p>Configure hotspot calculation</p>
                <md-button class="md-icon-button" @click="doMenu()">
                    <md-icon>settings</md-icon>
                    <md-tooltip md-direction="top">Configure hotspot calculation</md-tooltip>
                </md-button>
            </md-app-toolbar>
            <md-app-content id="main" tabindex="-1">
                <router-view />
            </md-app-content>
        </md-app>
    </div>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
// @ is an alias to /src

// import { earthbloxCollection } from "@/firebase.js";
// import { AuthService } from "./services/auth.service";
// import { ConfigService } from '@/services/config.service';

export default {
    name: "AppDashboard",
    data: () => ({
        banner: null,
        helpGuide: null,
        menuVisible: true,
    }),
    methods: {
        doMenu() {
            this.$root.$emit('menu-clicked');
        }
    },
    created() {
        console.info("Strata Open Access Dashboard created");
    }
};
</script>
